<script setup>
import Help from '@/Components/Help.vue';

defineProps({
  title: String,
  description: String,
  tooltip: String
});
</script>

<template>
  <div class="flex items-center">
    <span class="font-bold">
      {{ title }}
      <span class="font-normal">({{ description }})</span>
    </span>
    <Help class="ml-2" :size="20" :text="tooltip" />
  </div>
</template>
